<mat-card appearance="outlined" class="container-fluid container">
    <mat-card-title>
        <span class="title">Création manuelle de facture</span>
        <span>Veuillez choisir une référence 1 pour la création manuelle</span>
    </mat-card-title>

    <mat-card-content style="z-index: 1000" class="container-content content">
        <form [formGroup]="ref1DetailForm">
            <div class="dropDownStyle">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>R&Eacute;F&Eacute;RENCE 1 </mat-label>
                    <input matInput formControlName="PrimaryReference" type="text" hidden>
                    <ng-multiselect-dropdown
                        class="customDropDown"
                        placeholder='Sélectionner'
                        (onFilterChange)="onAssetFilterChange($event)"
                        [settings]="dropDownSettingsAssets"
                        [data]="dropDownDataAssets"
                        formControlName="PrimaryReference"
                        [(ngModel)]="selectedAsset"
                        ngDefaultControl>
                    </ng-multiselect-dropdown>
                </mat-form-field>
            </div>
        </form>
    </mat-card-content>

    <hr>
    <mat-card-footer class="footer">
        <div class="modal-footer d-table w-100">
            <div class="d-table-cell">
                <button tabindex="-1" mat-stroked-button class="currentBtn" (click)="close();">Annuler</button>
            </div>
            <div class="d-table-cell tar">
                <button tabindex="-1" mat-stroked-button class="currentBtnColor" (click)="onSubmit()">Création de la
                    facture</button>
            </div>
        </div>
    </mat-card-footer>
</mat-card>